import { render, staticRenderFns } from "./TermsHaveAcceptData.vue?vue&type=template&id=6dfdb48a&scoped=true"
import script from "./TermsHaveAcceptData.vue?vue&type=script&lang=js"
export * from "./TermsHaveAcceptData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdb48a",
  null
  
)

export default component.exports